import { LinkPanel } from '@navikt/ds-react'
import React from 'react'

export const Links: React.FC = (): JSX.Element => (
  <div className='w-links'>
    <LinkPanel href='#'>
      <LinkPanel.Title>
        Consectetur eu duis aliqua eu irure fugiat fugiat eu.
      </LinkPanel.Title>
      <LinkPanel.Description>
        Velit mollit do commodo elit Lorem aliqua Lorem.
      </LinkPanel.Description>
    </LinkPanel>
  </div>
)

export default Links
